import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareIcon, CalendarCheckIcon, BellIcon } from 'lucide-react';
export function AIWorkflowDemo() {
  const workflows = [{
    step: '1',
    icon: MessageSquareIcon,
    title: 'Customer Inquiry',
    description: 'Customer reaches out about a landscaping design project on your platform',
    example: '"Hi, I\'m interested in getting a landscape design for my backyard. Do you have availability?"'
  }, {
    step: '2',
    icon: BellIcon,
    title: 'AI Responds Instantly',
    description: 'Your AI assistant responds within seconds and directs them straight to booking',
    example: '"Thank you for your interest! I can help you schedule an on-site estimate. Click the link below to choose a time that works best for you: [Booking Link]"'
  }, {
    step: '3',
    icon: CalendarCheckIcon,
    title: 'Estimate Booked',
    description: 'Customer books their on-site estimate, syncs to your calendar, and receives confirmation',
    example: 'On-site estimate booked for Thursday 10am • Reminder sent • Added to CRM pipeline'
  }];
  return <section className="py-20 px-6 bg-gradient-to-br from-[var(--jet-black)] to-[var(--graphite-gray)] text-white" data-id="element-2">
      <div className="max-w-6xl mx-auto" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-4">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-5">
            See It In Action
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-6">
            Watch how our AI automation turns inquiries into booked
            appointments—automatically.
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-7">
          {workflows.map((workflow, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex flex-col md:flex-row gap-6 items-start bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10" data-id="element-8">
              <div className="flex items-center gap-4 md:w-1/3" data-id="element-9">
                <div className="flex-shrink-0 w-12 h-12 bg-[var(--viridia-green)] rounded-full flex items-center justify-center font-bold text-xl" data-id="element-10">
                  {workflow.step}
                </div>
                <div data-id="element-11">
                  <workflow.icon className="w-8 h-8 text-[var(--viridia-green)] mb-2" data-id="element-12" />
                  <h3 className="text-xl font-bold" data-id="element-13">{workflow.title}</h3>
                </div>
              </div>

              <div className="md:w-2/3" data-id="element-14">
                <p className="text-gray-300 mb-3" data-id="element-15">{workflow.description}</p>
                <div className="bg-[var(--jet-black)] rounded-lg p-4 border-l-4 border-[var(--viridia-green)]" data-id="element-16">
                  <p className="text-sm text-gray-400 italic" data-id="element-17">
                    "{workflow.example}"
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-12 text-center" data-id="element-18">
          <div className="inline-block bg-[var(--viridia-green)]/20 border border-[var(--viridia-green)] rounded-lg p-6" data-id="element-19">
            <p className="text-lg font-semibold" data-id="element-20">
              ⚡ Average response time:{' '}
              <span className="text-[var(--viridia-green)]" data-id="element-21">8 seconds</span>
            </p>
            <p className="text-sm text-gray-400 mt-2" data-id="element-22">
              vs. industry average of 47 minutes
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}